import React, { Suspense } from "react";
import LoadingPage from "../components/CommanComponents/LoadingPage1";
import Dashboard from "../components/Dashboard/Dashboard";
const Login = React.lazy(() => import("../components/BeforeLogin/Login"));
const ForgotPassword = React.lazy(() =>
  import("../components/BeforeLogin/ForgotPassword")
);
const RecoverPassword = React.lazy(() =>
  import("../components/BeforeLogin/RecoverPassword")
);
const UpdateProfile = React.lazy(() =>
  import("../components/Profile/UpdateProfile")
);
const ManageServiceType = React.lazy(() =>
  import("../components/Administrator/ManageServiceType/Index")
);
const ManageFinanceType = React.lazy(() =>
  import("../components/Administrator/ManageFinanceType/Index")
);
const ManageInsurance = React.lazy(() =>
  import("../components/Administrator/ManageInsurance/Index")
);
const ManageCarType = React.lazy(() =>
  import("../components/Administrator/ManageCarType/Index")
);
const ManageCarBroker = React.lazy(() =>
  import("../components/Administrator/ManageCarBroker/Index")
);
const ManageCarBrandType = React.lazy(() =>
  import("../components/Administrator/ManageCarBrandType/Index")
);
const ManageLocation = React.lazy(() =>
  import("../components/Administrator/ManageLocation/Index")
);
const ManagePersonList = React.lazy(() =>
  import("../components/Administrator/ManagePersonList/Index")
);
const ManageYearlyGoals = React.lazy(() =>
  import("../components/Administrator/ManageYearlyGoals/Index")
);
const TeamStatistics = React.lazy(() =>
  import("../components/Reports/TeamStatistics")
);
const CompanyStatistics = React.lazy(() =>
  import("../components/Reports/CompanyStatistics")
);
const TimeStatistics = React.lazy(() =>
  import("../components/Reports/TimeStatistics")
);
const MyStatistics = React.lazy(() =>
  import("../components/Reports/MyStatistics")
);
const Sales = React.lazy(() =>
  import("../components/Reports/Sales")
);
const ChangePassword = React.lazy(() =>
  import("../components/Profile/ChangePassword")
);
const UserGoals = React.lazy(() =>
  import("../components/Profile/UserGoals")
);


export const appRoutes = [
  {
    exact: true,
    path: "/",
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <Login />
      </Suspense>
    ),
  },
  {
    exact: true,
    path: "/forgotpassword",
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <ForgotPassword />
      </Suspense>
    ),
  },
  {
    exact: true,
    path: "/recover_password",
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <RecoverPassword />
      </Suspense>
    ),
  },
];

export const privateRoutes = [
  {
    path: "/administration/financing_types",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <ManageFinanceType />
      </Suspense>
    ),
  },
  {
    path: "/administration/insurances",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <ManageInsurance />
      </Suspense>
    ),
  },
  {
    path: "/administration/service_types",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <ManageServiceType />
      </Suspense>
    ),
  },
  {
    path: "/administration/car_brokers",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <ManageCarBroker />
      </Suspense>
    ),
  },
  {
    path: "/administration/myprofile",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <UpdateProfile />
      </Suspense>
    ),
  },
  {
    path: "/administration/change-password",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <ChangePassword />
      </Suspense>
    ),
  },
  {
    path: "/administration/car_types",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <ManageCarType />
      </Suspense>
    ),
  }, {
    path: "/administration/brands",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <ManageCarBrandType />
      </Suspense>
    ),
  },{
    path: "/administration/locations",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <ManageLocation />
      </Suspense>
    ),
  },{
    path: "/administration/salesperson",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <ManagePersonList />
      </Suspense>
    ),
  },
  {
    path: "/administration/yearlygoals",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <ManageYearlyGoals />
      </Suspense>
    ),
  },
  {
    path: "/goals",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <UserGoals />
      </Suspense>
    ),
  },
  {
    path: "/sales",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <Sales />
      </Suspense>
    ),
  },
  {
    path: "/dashboard",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <Dashboard />
      </Suspense>
    ),
  },{
    path: "/statistics/team",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <TeamStatistics />
      </Suspense>
    ),
  },{
    path: "/statistics/company",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <CompanyStatistics />
      </Suspense>
    ),
  },{
    path: "/statistics/time",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <TimeStatistics />
      </Suspense>
    ),
  },{
    path: "/statistics/me",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <MyStatistics />
      </Suspense>
    ),
  }
];
